var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Visitor_AFRAME"},[_c('div',{staticClass:"Visitor_AFRAME__header"},[_vm._v("AFRAME")]),_c('a-scene',[_c('a-entity',{attrs:{"foo":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }